import { IDataTableColumn, Loading } from "nsitools-react";
import * as React from "react";

import { BreedApi, BreedSearch, BreedGridDto } from "../../../../api";
import { ICustomSelectorProps, SRSHCustomSelector } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";

export interface IRequestBreedTransientSelectionProps
  extends Pick<ICustomSelectorProps<any>, "linkedIds" | "onLinkedIdsChanged"> {
  editMode: boolean;
  loading: boolean;
}

export const RequestBreedTransientSelection: React.FunctionComponent<IRequestBreedTransientSelectionProps> = ({
  editMode,
  linkedIds,
  onLinkedIdsChanged,
  loading,
}) => {
  const api = useApiService(BreedApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.BreedName),
        fieldName: "name",
        render: (row: BreedGridDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${row.breedId}/detail/view`}>{`${row.name}`}</Link>
        ),
      },
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        fieldName: "breedGroupLabel",
      },
    ],
    [t]
  );

  const searchIdsFunction = React.useCallback(
    (sObj: any) => api.getIds(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  const searchFunction = React.useCallback(
    (sObj: any) => api.baseSearch(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <Loading isLoading={loading || linkedIds === null}>
      <SRSHCustomSelector
        linkedIds={linkedIds}
        columns={columns}
        onLinkedIdsChanged={onLinkedIdsChanged}
        idField="breedId"
        searchFunction={searchFunction}
        searchIdsFunc={searchIdsFunction}
        editMode={editMode}
      />
    </Loading>
  );
};
